import PropTypes from "prop-types"
import React, { useContext } from "react"

import { HelpdeskContext } from "contexts/helpdesk"

/**
 * High Order Component for check article change
 * @param {React Component} WrappedComponent
 */
const withArticle = (WrappedComponent) => (props) => {
  const { state } = useContext(HelpdeskContext)
  const InternalWithArticle = ({ article, ...props }) => {
    return <WrappedComponent {...props} article={article} />
  }
  const mapStateToProps = {
    article: state.article,
  }

  const mapDispatchToProps = {}

  InternalWithArticle.propTypes = {
    article: PropTypes.object,
  }

  const combineProps = {
    ...props,
    ...mapStateToProps,
    ...mapDispatchToProps,
  }

  return InternalWithArticle(combineProps)
}

export default withArticle
